<template>
  <div>
    <el-row>
      <el-col :span="24">
        <img class="banner" src="@/assets/images/cooperation.png" alt=""
      /></el-col>
    </el-row>

    <div class="txt1">
      <h1>联系我们</h1>
      <img src="@/assets/images/ge.png" alt="" />
      <div class="txt3">
        <p>公司座机：021-65042373</p>
        <p>联系电话：+86 13167205771</p>
        <p>联系邮箱：info@facon-biomed.com</p>
        <p>办公地址：上海市宝山区高逸路172-2号科创小站A栋203室</p>
        <p>注册地址：江苏省苏州市太仓港经济技术开发区银港路52号</p>
      </div>
    </div>

    <div class="txt2">
      <h1>招商合作</h1>
      <img src="@/assets/images/ge.png" alt="" />
    </div>

    <el-row type="flex" justify="center">
      <el-col class="img">
        <img src="@/assets/images/hezuo2.png" alt="" />
      </el-col>
      <el-col :xs="20" :sm="10" :md="8">
        <div class="txt3">
          <h3>产品定制</h3>
          <p>
            根据合作伙伴的渠道和受众，定制精准化和个性化的检测产品及报告形式，完美契合用户需求。
          </p>
          <h3>运营统筹</h3>
          <p>对合作伙伴的市场推广提供运营支持。</p>
          <h3>技术支持</h3>
          <p>提供专业技术团队对客户进行专业知识宣讲及报告解读。</p>
          <h3>培训指导</h3>
          <p>定期为合作伙伴团队进行产品知识、运营流程、市场分析等培养。</p>
        </div></el-col
      >
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Cooperation",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.txt1 {
  text-align: center;
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
}
.txt2 {
  margin-top: 80px;
  text-align: center;
}
.txt3 {
  margin-top: 20px;
  h3 {
    color: rgb(100, 16, 173);
    margin-bottom: 5px;
  }
}
.el-row {
  flex-wrap: wrap;
}
.img {
  margin-top: 20px;
  width: 300px;
  img {
    width: 300px;
    height: auto;
  }
}
</style>
